var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('youtubeVisor',{attrs:{"video":_vm.video.video,"small":true}}),_c('h3',[_vm._v(_vm._s(_vm.video.title))]),_c('p',[_vm._v(" "+_vm._s(_vm.video.description)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }